import { baseURL } from '../httpService/API';
import { hMacAjax as fetch } from 'grt-tool-lib-front';

let reqUrl = `${baseURL}/grt-user-center-service`;
export const url = {
    paperInfo: `${reqUrl}/user/exam-practice`,
    startExamUrl: `${reqUrl}/user/exam-practice/start`,
    saveAnaswer: `${reqUrl}/user/exam-practice/question`,
    submitExamUrl: `${reqUrl}/user/exam-practice/submit`,
    myAnswerUrl: `${reqUrl}/user/exam-practice/answer`,
    answerInfoUrl: `${reqUrl}/user/exam-practice/info`,
    countCheck: `${reqUrl}/user/exam-practice/question/qualified/check`,
    paperPreviewUrl: `${baseURL}/grt-resource-manage-service/open/paper/student-paper/preview`,
    paperPreviewInfoUrl: `${reqUrl}/open/user/exam-practice`
};

export interface RequestResultType {
    success: boolean;
    code: string;
    msg: string;
    data: any;
    total?: number;
}

export const requestExamPracticeApi = async (data) => {
    return await fetch.get(url.paperInfo, data);
};
//点击开始考试
export const startExamApi = async (data: any): Promise<RequestResultType> => {
    return fetch.post(url.startExamUrl, data);
};

//答题
export const setAnswerApi = (data) => {
    return fetch.post(url.saveAnaswer, data);
};
//交卷
export const submitExamApi = (params) => {

    return fetch.post(url.submitExamUrl, params);
};

//my答案 考试中获取答案
export const getMyAnswerApi = (params) => {
    return fetch.get(url.myAnswerUrl, params);
};
//解析、答案
export const getAnswerInfoApi = (params) => {
    return fetch.get(url.answerInfoUrl, params);
};
//字数校验
export const countCheck = async (data: any): Promise<RequestResultType> => {
    return fetch.post(url.countCheck, data);
};

//预览
export const getPaperPreviewApi = (paperId) => {
    return fetch.get(url.paperPreviewUrl + '/' + paperId);
};

//查询试卷信息
export const getPaperPreviewInfoApi = (params) => {
    return fetch.get(url.paperPreviewInfoUrl, params);
};
